import mapValues from 'lodash.mapvalues';

export default function routeArgsToInt (route) {
  return mapValues(route.params, (val) => parseInt(val));
}
